/**
 * These types used by form entities, not directly through the document
 */
export type FormType = {
  formId: string;
  slug: string;
  name: string;
  description: string;
  segmentationEnabled: boolean;
  segmentIoEnabled: boolean;
  createdAt: string;
};

export type FormResponseCount = {
  id: string;
  responseCount: number;
};

export type MostRecentFormSubmission = {
  formId: string;
  mostRecentSubmission: string;
};

export type FormField = {
  formFieldId: string;
  formId: string;
  formLabel: string;
  slug: string;
  inputType: 'Email' | 'Checkbox' | 'Text' | 'Select' | 'MultiSelectCard' | 'SingleSelectCard';
};

export type FormResponse = {
  id: string;
  formId: string;
  userId: string;
  values: Record<string, unknown>;
  createdAt: string;
};

export enum FormResponseAction {
  DeleteResponses = 'bulkDelete',
  DownloadCSV = 'uploadAndRetrieveCsv',
}

export enum FormResponseFinder {
  FormIdAndUserId = 'byFormIdAndUserId',
  FormId = 'byFormId',
}
export enum FormFieldFinder {
  FieldForForm = 'getFieldsForForm',
}
